export default {
  props: {
    highlightedScore: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedScore: ''
    };
  },
  methods: {
    scoreClasses(score) {
      return ['el-card__wrapper', this.highlightedScore === score ? 'el-card__wrapper--highlighted' : null];
    },
    highlightScore(score, highlight = true) {
      this.selectedScore = score;
      setTimeout(() => {
        if (this.selectedScore === score && highlight) this.$emit('highlightScore', score);
      },
      1000);
    },
    unHighlightScore(score) {
      this.selectedScore = '';
      this.$emit('disHighlightScore', score);
    },
    focusScore(score) {
      const findTable = Array.from(document.querySelectorAll('.el-table.el-table--scrollable-x')).find(el => !!el.getClientRects().length);
      const findStickyTable = Array.from(document.querySelectorAll('.el-tabs__content')).find(el => !!el.getClientRects().length);
      const table = findTable || findStickyTable;
      const fixedTableColumns = Array.from(table.querySelectorAll('.el-table__fixed')).find(el => !!el.getClientRects().length);
      const tableHeaders = Array.from(table.querySelectorAll('thead.is-group tr')).find(el => el.textContent.includes(this.normalizeString(score)) && !!el.getClientRects().length);
      const findTableWrapper = table.querySelector('.el-table__body-wrapper');
      const findStickyWrapper = Array.from(table.querySelectorAll('.tab-container')).find(el => !!el.getClientRects().length);
      const tableWrapper = findStickyWrapper || findTableWrapper;
      let space = 0;

      Array.from(tableHeaders.childNodes).find((el) => {
        if (el.textContent.includes(this.normalizeString(score))) return true;

        space += el.clientWidth;

        return false;
      });

      let left = space - (tableWrapper.clientWidth / 2);

      if (fixedTableColumns) {
        left = space - fixedTableColumns.clientWidth;
      }

      tableWrapper.scroll({
        left,
        behavior: 'smooth'
      });
    }
  }
};
